/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sources_View_FilesInputs */

const es_components_sources_view_files = /** @type {(inputs: Components_Sources_View_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Archivos`)
};

const en_components_sources_view_files = /** @type {(inputs: Components_Sources_View_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Files`)
};

/**
* | output |
* | --- |
* | "View Files" |
*
* @param {Components_Sources_View_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_sources_view_files = /** @type {((inputs?: Components_Sources_View_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sources_View_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_sources_view_files(inputs)
	return en_components_sources_view_files(inputs)
});
export { components_sources_view_files as "components.sources.view_files" }